// @flow

import React, {PureComponent} from 'react'
import {bem} from '../../shared/bem'
import {mandatfordelingTable__cell as cell} from './index.css'

import type {Element} from 'react'

type CellProps = {
  type: string,
  row: number,
  offset?: number,
  children?: ?Element<any>
}
export class Cell extends PureComponent {
  props: CellProps

  render() {
    const {type, row, children, offset} = this.props
    return (
      <div
        className={bem(cell, type, offset ? `offset${offset}` : null)}
        data-row={row}
        data-column={type}
      >
        {children}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/mandatfordeling/MandatfordelingTable/cell.js